import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { FillingStationAreaModel } from '../../../api/fillingstationarea/fillingstationarea';
import { FillingStationAreaService } from '../../../api/fillingstationarea/fillingstationarea.service';

import { CountryGroupService } from '../../../api/countrygroup/countrygroup.service';
import { CountryModel } from '../../../api/country/country';

import { MasterDataConstant } from '../../../api/masterdata.constant';

declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
    selector: 'fillingstationarea-page',
    templateUrl: './fillingstationarea.html'
})
export class FillingStationAreaComponent implements OnInit {

    countryList: CountryModel[];

    fillingstationareaList: FillingStationAreaModel[];
    fillingstationarea : FillingStationAreaModel;

    fillingstationsearchList : any;
    fillingstationList : any;

    id: string;
    i: number;
    name : string = "";
    description : string = "";

    selectCountryCode : String = "";

    filtercountrycode : string = "All";

    searchfillingstationContent : string = "";

    searchAreaContent : string = "";

    constructor(private masterdataservice : MasterDataConstant,
        private countrygroupservice: CountryGroupService,
        private fillingstationareaService: FillingStationAreaService, 
        private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' ||  localStorage.getItem('type') == 'GENEROSITY')) {
            $(function () {
            });
            this.countrygroupservice
            .allCountryList()
            .then(data => {
                this.countryList = data
                this.filtercountrycode = "All";
                this.initFillingStationArea();
            });
        } else {
            this.router.navigate(['/']);
        }
    }
    initFillingStationArea() {
        var rrData = {
            countrycode : this.filtercountrycode
        }
        this.fillingstationareaService
            .allData(rrData)
            .then(
                data => {
                    this.fillingstationareaList = data
                } 
            );
    }
    cancelAction() 
    {
        this.name = "";
        this.description = "";
        this.selectCountryCode = "";
    }
    saveFillingStationArea() {
        if (this.name == undefined || this.name == "" || this.name == null) 
        {
            $.notify({
                message: "Please Enter Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.selectCountryCode == undefined || this.selectCountryCode == "" || this.selectCountryCode == null) 
        {
            $.notify({
                message: "Please Select Country"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        let iFillingStationArea = {
            name: this.name,
            description: this.description,
            countrycode: this.selectCountryCode
        }
        this.fillingstationareaService
            .SaveFillingStationArea(iFillingStationArea)
            .then(data => {
                if (data.status == true) {
                    this.fillingstationareaList.splice(0, 0,data.data)
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    this.cancelAction();
                    $(function () 
                    {
                        $("#fillingstationareaaddModal").modal('toggle');
                    });
                    this.masterdataservice.AreaList = [];
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    showFillingStationArea(filling, i) {
        this.i = i;
        this.fillingstationarea = filling;
        this.id = filling.id;
        this.name = filling.name;
        this.description = filling.description;
        this.selectCountryCode = filling.countrycode;
    }
    ExternalMapLocation(lati,longi)
    {
        window.open("https://maps.google.com/?q="+lati+","+longi, "_blank");
    }
    AddNewFillingStationAreaClick()
    {
        this.cancelAction();
        this.selectCountryCode = "Select";
        $(function () 
        {
            $('#fillingstationareaaddModal').modal('toggle');
        });
    }
    updateFillingStationArea() {
        if (this.name == undefined || this.name == "" || this.name == null) 
        {
            $.notify({
                message: "Please Enter Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if ((this.selectCountryCode == undefined || this.selectCountryCode == "" || this.selectCountryCode == null) || (this.selectCountryCode == "Select")) 
        {
            $.notify({
                message: "Please Select Country"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
         var uFillingStationArea = {
            name: this.name,
            description: this.description,
            countrycode : this.selectCountryCode
        }
        this.fillingstationareaService
            .UpdateFillingStationArea(this.id, uFillingStationArea)
            .then(data => {
                if (data.status == true) {
                    //this.initFillingStationArea();
                    this.fillingstationareaList[this.i] = data.data;
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    this.cancelAction()
                    $(function () {
                        $('#fillingstationareaupdateModal').modal('toggle');
                    });
                    this.masterdataservice.AreaList = [];
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    onFilterCountryChange(filCountry)
    {
        this.filtercountrycode = filCountry;
        this.initFillingStationArea();
    }
    getstationByAreaId(fillingstationarea,i)
    {
        this.fillingstationsearchList = [];
        this.fillingstationList = [];

        this.i = i;
        this.fillingstationarea = fillingstationarea;
        var rrData = {
            areaid : fillingstationarea.id
        }
        this.fillingstationareaService
            .GetFillingStationByAreaId(rrData)
            .then(
                data => {
                    this.fillingstationList = data;
                    this.searchfillingstationContent = "";
                    $(function () {
                        $('#fillingstationlistModal').modal('toggle');
                    });
                } 
            );
    }

    searchfillingstation()
    {
        if (this.searchfillingstationContent == undefined || this.searchfillingstationContent == "" || this.searchfillingstationContent == null) 
        {
            $.notify({
                message: "Please Enter Search Text"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.searchfillingstationContent.length < 3) 
        {
            $.notify({
                message: "Please Enter Atleast 3 Character"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        var rrData = {
            search : this.searchfillingstationContent
        }
        this.fillingstationareaService
            .SearchFillingStation(rrData)
            .then(
                data => {
                    this.fillingstationsearchList = data
                } 
            );
    }
    LinkStation(fillingstation,i)
    {
        var uFillingStation = {
            areaid:  this.fillingstationarea.id,
            fillingstationid : fillingstation.id
        }
        this.fillingstationareaService
            .LinkFillingStationIntoArea(uFillingStation)
            .then(data => {
                if (data.status == true) 
                {
                    this.fillingstationareaList[this.i].fillingstationscount += 1;
                    this.fillingstationList.splice(0, 0,fillingstation)
                    this.fillingstationsearchList.splice(i, 1);
                   
                    $.notify({
                        message: "Filling Station Added"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                } else {
                    $.notify({
                        message: "Failed to Add"
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    UnlinkStation(fillingstation,i)
    {
        var uFillingStation = {
            fillingstationid : fillingstation.id
        }
        this.fillingstationareaService
            .UnlinkFillingStationIntoArea(uFillingStation)
            .then(data => {
                if (data.status == true) 
                {
                    this.fillingstationareaList[this.i].fillingstationscount -= 1;
                    if(this.fillingstationareaList[this.i].fillingstationscount < 0)
                    {
                        this.fillingstationareaList[this.i].fillingstationscount = 0;
                    }
                    this.fillingstationsearchList.splice(0, 0,fillingstation)
                    this.fillingstationList.splice(i, 1);

                    $.notify({
                        message: "Filling Station Removed"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                } else {
                    $.notify({
                        message: "Failed to Remove"
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    searchAreaList()
    {
        var rrData = {
            search : this.searchAreaContent
        }
        this.fillingstationareaService
            .searcharealist(rrData)
            .then(
                data => {
                    this.fillingstationareaList = data
                } 
            );
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/fillingstationarea/fillingstationarea.page.ts